export const STORAGE_KEY = 'analytics_data';
type StorageData = { userId: string };

export function saveDataToStorage(data: StorageData) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function getDataFromStorage() {
  const storageData = localStorage.getItem(STORAGE_KEY);

  if (!storageData) {
    return null;
  }

  return JSON.parse(storageData) as StorageData;
}
